module.exports = __webpack_public_path__ + "img/steps.422e384c.svg";